<template>
  <div data-testid="message-placeholder">
    <section class="list-item">
      <article
        class="list-item__message list-item__message--placeholder list-item__member"
        data-placeholder
      >
        <WParagraph class="list-item__author"></WParagraph>
        <WParagraph class="list-item__message"></WParagraph>
        <WParagraph class="list-item__message"></WParagraph>
      </article>
    </section>
    <section class="list-item">
      <article
        class="list-item__message list-item__message--placeholder list-item__user"
        data-placeholder
      >
        <WParagraph class="list-item__author"></WParagraph>
        <WParagraph class="list-item__message"></WParagraph>
        <WParagraph class="list-item__message"></WParagraph>
      </article>
    </section>
    <section class="list-item">
      <article
        class="list-item__message list-item__message--placeholder list-item__member"
        data-placeholder
      >
        <WParagraph class="list-item__author"></WParagraph>
        <WParagraph class="list-item__message"></WParagraph>
        <WParagraph class="list-item__message"></WParagraph>
      </article>
    </section>
    <section class="list-item">
      <article
        class="list-item__message list-item__message--placeholder list-item__user"
        data-placeholder
      >
        <WParagraph class="list-item__author"></WParagraph>
        <WParagraph class="list-item__message"></WParagraph>
        <WParagraph class="list-item__message"></WParagraph>
      </article>
    </section>
  </div>
</template>

<script>
import { WParagraph } from '@alice-health/wonderland-vue'

export default {
  components: { WParagraph }
}
</script>

<style lang="scss" scoped>
@import '@/style/_non-rendering';

.list-item {
  display: grid;
  padding: 0 var(--gl-spacing-04);
}
.list-item__message.list-item__message--placeholder {
  cursor: initial;
  position: relative;

  opacity: 0.5;

  padding: var(--gl-spacing-02);

  .list-item__author {
    width: 30%;
    height: 10px;
    background: var(--gl-color-shades-gray-20);
    border-radius: var(--gl-border-radius-xs);
    margin: var(--gl-spacing-02) 0;
  }

  .list-item__message {
    width: 100%;
    height: 10px;
    margin: var(--gl-spacing-02) 0;
    background: var(--gl-color-shades-gray-20);
    border-radius: var(--gl-border-radius-xs);
  }

  &::after {
    @extend %skeleton;
  }
}
.list-item__member {
  width: 40%;
  background-color: var(--gl-color-shades-magenta-70);
  border-radius: var(--gl-border-radius-md);
  border-bottom-left-radius: var(--gl-border-radius-xs);
  grid-column: 1/3;
}
.list-item__user {
  width: 100%;
  border: var(--gl-border-width-xs) solid var(--message-staff-border-color);
  background-color: var(--gl-color-shades-white);
  border-radius: var(--gl-border-radius-md);
  border-bottom-right-radius: var(--gl-border-radius-xs);
  grid-column: 3/3;
}
</style>
